'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeFilteredResourcesSelector = exports.makeGetResourceSelector = exports.makeResourceTypeSelector = undefined;

var _lodash = require('lodash');

var _reselect = require('reselect');

var _immutableHelper = require('../../../../../common/utils/immutableHelper');

// Resources manage the loading state
// these are all curried methods that are called with a particular resource type (user/board/element)
// ==================================

var makeResourceTypeSelector = exports.makeResourceTypeSelector = function makeResourceTypeSelector(resourceType) {
    return function (state) {
        return state.getIn(['resources', resourceType]);
    };
};

// gets a single resource for an id


// Utils
// Lib
var makeGetResourceSelector = exports.makeGetResourceSelector = function makeGetResourceSelector(resourceType) {
    return function (state, _ref) {
        var id = _ref.id;
        return state.getIn(['resources', resourceType, id]);
    };
};

// give an array of ids, the resource entry matching each id
var makeFilteredResourcesSelector = exports.makeFilteredResourcesSelector = (0, _lodash.curry)(function (resourceType, resourceIdsSelector) {
    return (0, _reselect.createSelector)(resourceIdsSelector, makeResourceTypeSelector(resourceType), _immutableHelper.getMany);
});


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/http/resources/resourceSelector.js
// module id = 472
// module chunks = 0